module.exports = __webpack_public_path__ + "img/4-道具中心-03.d2f7b9d6.png";